import { IFilter } from "src/@redux/listRedux";
import commonDataAccess from "../commonDataAccess";

class policiesDataAccess {
    policyList = async (params: {
        pageNo;
        pageSize;
        sortData;
        filters: Array<IFilter>;
    }) => {
        let _filters = {};
        console.log(params.filters);
        params.filters.forEach((item) => {
            if (item.value && item.value.length > 0) {
                _filters["filter." + item.propertyName] = item.value + "-" + item.type;
            }
        });
        let parameters = {
            pageNo: params.pageNo,
            pageSize: params.pageSize,
            sortPreference: params.sortData,
            ..._filters,
        };
        return await commonDataAccess.getData(
            "Policies/getAll",
            parameters
        );
    };

    getPolicyById = (procedureId: number) => {
        return commonDataAccess.getData("Policies/get/policies", {
            id: procedureId,
        });
    };
    savePolicy = (payload: FormData, docHistoryName: string) => {
        return commonDataAccess.postFormData(
            "Policies/save",
            payload,
            {
                docHistoryName: docHistoryName,
            }
        );
    };

    deletePolicy = (ids: number | number[]) => {
        if (Array.isArray(ids)) {
            return commonDataAccess.postData("Policies/deleteAll", ids);
        } else {
            return commonDataAccess.deleteData(`Policies/delete/${ids}`);
        }
    }

    getPolicyDocumentList = (params: {
        pageNo;
        pageSize;
        sortData;
        filters: Array<IFilter>;
    }) => {
        let _filters = {};
        params.filters.forEach((item) => {
            if (item.value && item.value.length > 0) {
                _filters["filter." + item.propertyName] = item.value + "-" + item.type;
            }
        });
        let parameters = {
            pageNo: params.pageNo,
            pageSize: params.pageSize,
            sortPreference: params.sortData,
            ..._filters,
        };
        return commonDataAccess.getData("Policies/getPoliciesDocumentList", parameters);
    };

    getPoliciesDropdown = () => {
        return commonDataAccess.getData("Policies/get/policiesDropdownList");
    };
}

export default new policiesDataAccess();